<template>
  <div class="card">
    <div v-if="customers" class="table-responsive">
      <table class="table table-xs font-size-xs" :id="dataTable.id">
        <thead>
          <tr>
            <th></th>
            <th>Nome</th>
            <th>Telefone</th>
            <th>Status</th>
            <th>Tipo</th>
            <th>Classificação</th>
          </tr>
        </thead>
        <tbody>
          <tr v-for="customer in customers" :key="customer.clientId">
            <td>
              <div
                class="
                  custom-control custom-checkbox
                  mb-2
                  d-flex
                  align-items-center
                "
              >
                <input
                  type="checkbox"
                  class="custom-control-input"
                  :id="`C_${customer.clientId}`"
                  :value="customer.clientId"
                  :checked="
                    customer.PS_CLIENTE_STATUS === 'Aguardando Avaliação'
                      ? true
                      : false
                  "
                  v-model="customer.isSelected"
                  @change="selectClient(customer.clientId)"
                />
                <label
                  class="custom-control-label"
                  :for="`C_${customer.clientId}`"
                ></label>
              </div>
            </td>
            <td>{{ customer.name }}</td>
            <td>
              <input
                type="text"
                class="form-control"
                v-model="customer.phone"
              />
            </td>

            <td>
              <div
                class="d-flex mr-2"
                v-html="customerLabelTranslate(customer.status)"
              ></div>
            </td>
            <td>{{ customer.typeName }}</td>
            <td>{{ customer.classification }}</td>
          </tr>
        </tbody>
      </table>
      <div class="card-footer d-flex justify-content-between">
        <div class="counter">
          <p>Clientes Selecionados: {{ numberOfSelectedCustomers }}</p>
        </div>
        <div class="buttons">
          <button class="btn btn-success" @click="prepareToSend()">
            Enviar NPS
          </button>
        </div>
      </div>
    </div>
  </div>
</template>
<style scoped>
.mw-type {
  min-width: 143px !important;
}
.mw-classification {
  min-width: 110px !important;
}
</style>
<script>
import LoadingData from '@/components/commons/LoadingData.vue'
import {
  customerLabelTranslate,
  customerClassLabelTranslate,
  satisfactionLabelTranslate,
  enchantmentLabelTranslate,
  questionSatisfactionTranslate,
  questionEnchantmentTranslate,
} from '@/utils/statusesTranslator'
import 'datatables.net-dt/js/dataTables.dataTables'
import '@/utils/basicDataTableExtend'
import { dateTimeSqlToDateBR } from '@/utils/date'

export default {
  name: 'DatatableSelectToMessage',

  components: {},

  props: {
    unityId: {
      type: Number,
      required: true,
    },
    periodId: {
      type: String,
      required: true,
    },
    customers: {
      type: Array,
      required: false,
    },
  },

  data() {
    return {
      customerLabelTranslate,
      selectedCustomers: [],
      numberOfSelectedCustomers: 0,
      dataTable: {
        id: 'dataTableListCustomers',
        columnDefs: [
          {
            orderable: false,
            width: 130,
            targets: [5],
          },
        ],
      },
    }
  },

  computed: {},
  watch: {
    customers: {
      handler(newVal, oldVal) {
        const selected = this.customers.filter(
          (customer) => customer.isSelected,
        )
        this.numberOfSelectedCustomers = selected.length
      },
    },
  },
  methods: {
    prepareToSend() {
      const selected = this.customers.filter((customer) => customer.isSelected)
      this.$emit('sendNPS', selected)
    },
    selectClient(id) {
      this.countSelectedCustomers()
    },
    createDataTable() {
      window.$(`#${this.dataTable.id}`).DataTable({
        columnDefs: this.dataTable.columnDefs,
        pageLength: 25, // quantidade de registro por página
        order: [4, 'asc'], // ordena
        lengthMenu: [
          [5, 10, 25, 50, -1],
          [5, 10, 25, 50, 'Todos'],
        ], // menu para alterar a quantidade de registro
      })
    },
    countSelectedCustomers() {
      const selected = this.customers.filter((customer) => customer.isSelected)
      this.numberOfSelectedCustomers = selected.length
    },
  },

  mounted() {
    this.createDataTable()
    this.countSelectedCustomers()
  },
}
</script>
